import * as _ from 'lodash';

import { api } from '../axiosConfig';
import {surveysURL, samplesURL} from "../Utils/urls";

export class SamplesAPI {
    static getAll(
        limit : any,
        currentPageNumber : number,
        payload: { [key: string]: any },
        offset = 0,
        sourceCountryOverride?: string,
    ): Promise<any[]> {
        const config = sourceCountryOverride
            ? { headers: { 'X-Selected-Country': sourceCountryOverride } }
            : undefined;
        return api.post(`${samplesURL}/getAll/${limit}/${currentPageNumber}`, payload, config).then((res) => {
            return _.get(res, 'data', []);
        });
    }

    static create(payload: { [key: string]: any }): Promise<any> {
        return api.post(`${samplesURL}/create`, payload)
            .then((res) => {
                return _.get(res, 'data.data', {});
            });
    }

    static getOne(
        id : string
    ): Promise<any[]> {
        return api.post(`${samplesURL}/getOne/${id}`, {})
        .then((res) => {
            return _.get(res, 'data.data', {});
        });
    }


    static getOneSampleUsers(
        id : string,
        page,
        limit
    ): Promise<any[]> {
        return api.post(`${samplesURL}/getOneSampleUsers/${id}?page=${page}&limit=${limit}`, {})
        .then((res) => {
            return _.get(res, 'data.data', {});
        });
    }

    static update(id: string, payload: { [key: string]: any }): Promise<any> {
        return api.post(`${samplesURL}/update/${id}`, payload)
            .then((res) => {
                return _.get(res, 'data.data', {});
            });
    }

    // payload is optional: the Edit Survey > Samples tab passes
    // { sourceCountryCode, country } from the row so the backend's
    // body-country resolution works when the navbar is at ALL.
    static deleteOne(id: string, payload: { [key: string]: any } = {}): Promise<any> {
        return api.post(`${samplesURL}/delete/${id}`, payload)
            .then((res) => {
                return _.get(res, 'data.data', {});
            });
    }


    static createQuestion(payload: { [key: string]: any }): Promise<any> {
        return api.post(`${samplesURL}/create-questions`, payload)
            .then((res) => {
                return _.get(res, 'data.data', {});
            });
    }

    static getOneQuestion(id: any): Promise<any> {
        return api.post(`${samplesURL}/get-SampleQuestion/${id}`, {})
            .then((res) => {
                return _.get(res, 'data.data', {});
            });
    }

    static getQuestions(secId: any): Promise<any> {
        return api.post(`${samplesURL}/get-SampleQuestions/${secId}`, {})
            .then((res) => {
                return _.get(res, 'data.data', []);
            });
    }

    static removeQuestion(id: any): Promise<any> {
        return api.post(`${samplesURL}/remove-question/${id}`, {})
            .then((res) => {
                return _.get(res, 'data.data', {});
            });
    }

    static uploadUniqueLinks(payload: { [key: string]: any }, id: string): Promise<any> {
        return api.post(`${samplesURL}/uploadUniqueLinks?id=${id}`, payload)
            .then((res) => {
                return _.get(res, 'data.data', {});
            });
    }
    static Total_no_panelist(sourceCountryOverride?: string): Promise<any> {
        const config = sourceCountryOverride
            ? { headers: { 'X-Selected-Country': sourceCountryOverride } }
            : undefined;
        return api.post(`${samplesURL}/noOfPanelistCount`, {}, config)
            .then((res) => {
                return (res);
            });
    }
    static targetpanelistAPI(payload: { [key: string]: any }, sourceCountryOverride?: string): Promise<any> {
        const config = sourceCountryOverride
            ? { headers: { 'X-Selected-Country': sourceCountryOverride } }
            : undefined;
        return api.post(`${samplesURL}/noOfPanelistCount`, payload, config)
            .then((res) => {
                return res;
            })

    }
    
    static getOneSampleUsersexport(
        id : string
    ): Promise<any[]> {
        return api.post(`${samplesURL}/getOneSampleUsersexport/${id}`, {})
        .then((res) => {
            return _.get(res, 'data', {});
        });
    }

    static getOneSampleUsersexportBlob(
        id: string,
        payload: { [key: string]: any } = {},
    ): Promise<Blob> {
        return api.post(`${samplesURL}/getOneSampleUsersexport/${id}`, payload, {
            responseType: 'blob',
        }).then((res) => {
            return res.data as Blob;
        });
    }

    
    static getsegmentwisedetails(
        payload : any
    ): Promise<any[]> {
        return api.post(`${samplesURL}/getsegmentwisedetails`, payload)
        .then((res) => {
            return _.get(res, 'data', {});
        });
    }
    



  
static uploadFileUniqueIds(payload: { [key: string]: any }): Promise<any> {
    return api.post(`${samplesURL}/SampleUserMetdata`, payload)
        .then((res) => {
            return _.get(res, 'data.data', {});
        });
}  

static updateSampleUserMetdata(payload: { [key: string]: any }): Promise<any> {
    return api.post(`${samplesURL}/updateSampleUserMetdata`, payload)
        .then((res) => {
            return _.get(res, 'data.data', {});
        });
} 

static getAllSampleBasedOnSurvey(payload: { [key: string]: any }): Promise<any> {
    return api.post(`${surveysURL}/getAllSampleBasedOnSurvey`, payload)
        .then((res) => {
            return _.get(res, 'data.data', []);
        });
}

static createAndLink(
    payload: { [key: string]: any },
    childSurveyId: string,
    sourceCountryCode: string,
    countryName: string,
): Promise<any> {
    const enriched = { ...payload, sourceCountryCode, country: countryName };
    return SamplesAPI.create(enriched)
        .then((sample: any) =>
            api.post(`${surveysURL}/linkSampleToSurvey`, { surveyId: childSurveyId, sampleId: sample.id })
               .then(() => sample)
        );
}

static unlinkSample(surveyId: string, sampleId: string): Promise<any> {
    return api.post(`${surveysURL}/unlinkSampleFromSurvey`, { surveyId, sampleId })
        .then((res) => _.get(res, 'data.data', {}));
}

static getSamplesByCountry(countryName: string): Promise<any[]> {
    return api.post(`${samplesURL}/getSamplesByCountry`, { countryName })
        .then((res) => _.get(res, 'data.data', []));
}


}
